import React from 'react';
import { styled } from '@mui/system';
import { Box } from '@mui/material';
import Breadcrumb from './Breadcrumb';

// STYLED COMPONENTS
const Container = styled("div")(({ theme }) => ({
    margin: "10px",
    [theme.breakpoints.down("sm")]: { margin: "16px" },
    "& .breadcrumb": {
        marginBottom: "10px",
        [theme.breakpoints.down("sm")]: { marginBottom: "16px" }
    }
}));

const PageLayout = ({ children, routeSegments }) => {
    return (
        <Container>
            <Box className="breadcrumb">
                <Breadcrumb routeSegments={routeSegments} />
            </Box>
            {children}
        </Container>
    );
};

export default PageLayout;